import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggingService } from '../../services/logging.service';
import { TenantRouterService } from '../../services/tenant-router.service';
import { ThankYouService } from '../../services/thank-you.service';

@Component({
  selector: 'app-thank-you',
  standalone: false,
  templateUrl: './thank-you.component.html',
  styleUrl: './thank-you.component.scss'
})
export class ThankYouComponent implements OnInit {
  userName: string = '';
  assessmentName: string = '';
  completionTime: Date = new Date();
  userId: number = 0;

  constructor(
    private router: Router,
    private loggingService: LoggingService,
    private tenantRouter: TenantRouterService,
    private thankYouService: ThankYouService,
  ) { }

  ngOnInit(): void {
    this.loggingService.logDebug("Thank you page initialized");

    // Get user information from session storage
    const currentUser = sessionStorage.getItem('currentUser');
    if (currentUser) {
      const user = JSON.parse(currentUser);
      this.userName = user.Name || user.name || 'User';
      this.userId = user.UserID;
    }

    // Get assessment information if available
    const assessmentData = sessionStorage.getItem('completed_assessment');
    if (assessmentData) {
      const assessment = JSON.parse(assessmentData);
      this.assessmentName = assessment.name || 'Assessment';
    }

    this.sendSummaryReportEmail();

    // Auto-redirect after 10 seconds (optional)
    //setTimeout(() => {
    // this.goToDashboard();
    //}, 10000);
  }

  sendSummaryReportEmail(): void {
    if (this.userId) {
      this.thankYouService.triggerSummaryReport(this.userId).subscribe({
        next: (response) => {
          this.loggingService.logDebug('Summary report email sent successfully', response);
        },
        error: (error) => {
          this.loggingService.logError('Failed to send summary report email', error);
        }
      });
    } else {
      this.loggingService.logError('Cannot send summary report: Invalid user ID');
    }
  }

  goToDashboard(): void {
    this.loggingService.logDebug("Redirecting to dashboard");
    this.tenantRouter.navigate('user-dashboard');
  }

  goToResults(): void {
    this.loggingService.logDebug("Redirecting to results");
    // Navigate to results page if available
    this.tenantRouter.navigate('results');
  }

  takeAnotherAssessment(): void {
    this.loggingService.logDebug("Redirecting to take another assessment");
    this.tenantRouter.navigate('user-dashboard');
  }
}